import React, { useEffect, useState } from "react";
import { Select } from "antd";

import { requestToken } from "../../../auth/AuthServices";
import HeaderFarms from "../../../utils/header_farms";
import API from "../../../services";
import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";


const { Option, OptGroup } = Select;

const DistributionSelect = ({ value, onChange, size, placeholder }) => {

  const [distribution, setDistribution] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDistribution = async () => {
    try {
      const token = await requestToken()

      const [resTank, resVehicle] = await Promise.all([
        API.StorageTank(HeaderFarms(token), null),
        API.TankerVehicle(HeaderFarms(token), null),
      ]);

      const tanks = resTank.data || [];
      const vehicles = resVehicle.data || [];

      const tankList = tanks.map((item) => ({
        type: "Tank Storage",
        label: `${item.tank_code} - ${item.location}`,
        value: item.tank_code,
      }));

      const vehicleList = vehicles.map((item) => ({
        type: "Fuel Truck",
        label: `${item.vehicle_number} - ${item.owner}`,
        value: item.vehicle_number,
      }));

      setDistribution([...vehicleList, ...tankList]);
    } catch (err) {
      console.error("Distribution fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDistribution();
  }, []);

  return (
    <Select
      style={{ width: "100%" }}
      size={size}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      loading={loading}
      showSearch
      suffixIcon={
        distribution.length > 0 ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: 18 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: 18 }} />
        )
      }
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toLowerCase().includes(input.toLowerCase())
      }
      labelInValue={false}
    >
      <OptGroup label="Fuel Truck">
        {distribution
          .filter((item) => item.type === "Fuel Truck")
          .map((item) => (
            <Option key={item.value} value={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
      </OptGroup>
      <OptGroup label="Tank Storage">
        {distribution
          .filter((item) => item.type === "Tank Storage")
          .map((item) => (
            <Option key={item.value} value={item.value} label={item.label}>
              {item.label}
            </Option>
          ))}
      </OptGroup>
    </Select>
  );
};

export default DistributionSelect;
